module.exports = __webpack_public_path__ + "img/cinema_empty.337497e1.png";